// extracted by mini-css-extract-plugin
export var orderSummary = "_ot-0";
export var showMoreLessButton = "_ot-1";